enum Constants {
  ACTION_GENERAL_COMMENT = `1`,
  ACTION_ADD_PRODUCT = `2`,
  ACTION_MODIFY_PRODUCT = `3`,
  ACTION_REMOVE_PRODUCT = `4`,
  ACTION_SWAP_PRODUCT = `5`,

  ACTION_GENERAL_COMMENT_LABEL = `General Comment`,
  ACTION_ADD_PRODUCT_LABEL = `Add Product`,
  ACTION_MODIFY_PRODUCT_LABEL = `Modify Product`,
  ACTION_REMOVE_PRODUCT_LABEL = `Remove Product`,
  ACTION_SWAP_PRODUCT_LABEL = `Swap Product`,

  REASON_APPROVED_CORE_NEW_ITEM_LABEL = `Approved Core/New item`,
  REASON_CAPACITY_LABEL = `Capacity`,
  REASON_DAYS_OF_SUPPLY_LABEL = `Days of Supply`,
  REASON_FLOW_LABEL = `Flow`,
  REASON_HURDLE_CRITERIA_LABEL = `Hurdle Criteria`,
  REASON_ITEM_NOT_APPROVED_LABEL = `Item Not Approved`,
  REASON_MARKET_PERFORMANCE_LABEL = `Market Performance`,
  REASON_OTHER_LABEL = `Other`,
  REASON_PLACEMENT_ORIENTATION_LABEL = `Placement / Orientation`,
  REASON_PRODUCT_UNAVAILABLE_LABEL = `Product Unavailable`,

  REASON_APPROVED_CORE_NEW_ITEM = `1`,
  REASON_CAPACITY = `2`,
  REASON_DAYS_OF_SUPPLY = `3`,
  REASON_FLOW = `4`,
  REASON_HURDLE_CRITERIA = `5`,
  REASON_ITEM_NOT_APPROVED = `6`,
  REASON_MARKET_PERFORMANCE = `7`,
  REASON_OTHER = `8`,
  REASON_PLACEMENT_ORIENTATION = `9`,
  REASON_PRODUCT_UNAVAILABLE = `10`,

  ATTACHMENTS_PDF_LABEL = `PDF File Extension`,
  ATTACHMENTS_PSA_LABEL = `PSA File Extension`,

  COMMENT_FORM_PRODUCT_DROPDOWN_PLACEHOLDER = `Products (Type 3 characters min.)`,
  COMMENT_FORM_SUB_PRODUCT_DROPDOWN_PLACEHOLDER = `With Product (Type 3 characters min.)`,

  CREATE_PROJECT_DEFAULT_NAME = `Untitled`,

  // Roles
  AB_SYSTEM_ADMIN = `AB System Admin`,
  // Commented AB Project Admin change to Internal Project Admin
  // AB_PROJECT_ADMIN = `AB Project Admin`,
  INTERNAL_PROJECT_ADMIN = `Internal Project Admin`,
  // Commented AB Collaborator changed to External Project Admin
  // AB_COLLABORATOR = `AB Collaborator`,
  EXTERNAL_PROJECT_ADMIN = `External Project Admin`,
  // Commented Retailer
  // RETAILER = `Retailer`,
  // Commented AB Viewer changed to Viewer
  // AB_VIEWER = `AB Viewer`,
  VIEWER = `Viewer`,
  // Commented AB Wholesaler
  // AB_WHOLESALER = `AB Wholesaler`,
  // Commented Viewer changed to Viewer_No_PSA_Access
  // VIEWER = `Viewer`,
  VIEWER_NO_PSA_ACCESS = `Viewer_No_PSA_Access`,
  // Commented Competitor Wholesaler changed to Contributor_No_PSA_Access
  // COMPETITOR_WHOLESALER = `Competitor Wholesaler`,
  CONTRIBUTER_NO_PSA_ACCESS = `Contributor_No_PSA_Access`,
  // Commented Competitor CSM changed to Contributor
  // COMPETITOR_CSM = `Competitor CSM`,
  CONTRIBUTER = `Contributor`,
  // Commented AB Region Category Director
  // AB_REGION_CAT_DIRECTOR = `AB Region Category Director`,
  // Commented AB Merchandiser
  // AB_MERCHANDISER = `AB Merchandiser`,

  // Validation Statuses
  NEEDS_VALIDATION = `NEEDS VALIDATION`,
  VALIDATION_IN_PROGRESS = `VALIDATION IN PROGRESS`,
  VALIDATION_COMPLETE = `VALIDATION COMPLETE`,
  // AWAITING_FINAL_UPLOAD = `AWAITING FINAL UPLOAD`,
  // FINAL_UPLOAD_COMPLETE = `FINAL UPLOAD COMPLETE`,
  // FEEDBACK_UNDER_REVIEW = `FEEDBACK UNDER REVIEW`,
  // NEEDS_FEEDBACK_REVIEW = `NEEDS FEEDBACK REVIEW`,
  FILES_AVAILABLE = 'FILES AVAILABLE',

  // Reset Statuses
  // RESET_NOT_SCHEDULED = `RESET NOT SCHEDULED`,
  RESET_SCHEDULED = `RESET SCHEDULED`,
  RESET_COMPLETE = `RESET COMPLETE`,

  // Project Types
  FILE_SHARING = `File Sharing`,
  VALIDATION = `Validation`,

  // File Types
  ORIGINAL = `ORIGINAL`,
  FINAL = `FINAL`,

  // Pill Types
  PILL_FILE_SHARING = `FILE SHARING`,
  PILL_MOBILE_FILE_SHARING = `MOBILE FILE SHARING`,

  // Project Status
  PUBLISHED = `PUBLISHED`,
  UNPUBLISHED = `UNPUBLISHED`,

  // Downloads
  DOWNLOAD_FILES_SUCCESS_MESSAGE = `Your files will be emailed soon.`,
  DOWNLOAD_FILES_ERROR_MESSAGE = `Something went wrong. Please try again.`,
  DOWNLOAD_FILES_DOWNLOAD_FAILED_MESSAGE = `Download failed. Please refresh your page before trying again.`,

  BREAKPOINT_LARGE = `large`,
  BREAKPOINT_MEDIUM = `medium`,
  BREAKPOINT_SMALL = `small`,
  BREAKPOINT_MOBILE = `mobile`,

  DATE_FORMAT__YYYY_MM_DD = `YYYY-MM-DD`,
  DATE_FORMAT__YYYY_MM_DD__HH_mm_ss = `YYYY-MM-DD HH:mm:ss`,
  DATE_FORMAT__EXPORT_FILE__YYYY_MM_DD__HH_mm = `YYYY-MM-DD--HHmm`,

  ERROR_403 = "403",
  ERROR_404 = "404",

  // Season Information
  SEASON_SPRING = `1`,
  SEASON_SUMMER = `2`,
  SEASON_FALL = `3`,
  SEASON_WINTER = `4`,
  SEASON_SPECIAL_PROJECT = `5`,

  SEASON_SPRING_LABEL = `Spring`,
  SEASON_SUMMER_LABEL = `Summer`,
  SEASON_FALL_LABEL = `Fall`,
  SEASON_WINTER_LABEL = `Winter`,
  SEASON_SPECIAL_PROJECT_LABEL = `Special Project`,

  IRIS_DOWNLOADS_QUERY = "iris.downloads.query",
  MY_STORES_QUERY = "my.stores.query",

  CHAIN_ACCESS ="CHAIN_ACCESS",
  USER_ONBOARDING_AND_CHAIN_ACCESS_BY_PROJECT_ADMIN ="USER_ONBOARDING_AND_CHAIN_ACCESS_BY_PROJECT_ADMIN",
  USER_ONBOARDING_AND_CHAIN_ACCESS_BY_ANONYMOUS = "USER_ONBOARDING_AND_CHAIN_ACCESS_BY_ANONYMOUS",
  CHAIN_ACCESS_BY_EXTERNAL_PROJECT_ADMIN = "CHAIN_ACCESS_BY_EXTERNAL_PROJECT_ADMIN",
  STAGE_PENDING ="PENDING",
  STAGE_APPROVED="APPROVED",
  STAGE_REJECTED="REJECTED",
  REQUEST_OPEN ="OPEN",
  REQUEST_PENDING_REVIEW = "PENDING_REVIEW",
  REQUEST_APPROVED="APPROVED",
  REQUEST_REJECTED= "REJECTED",
  REQUEST_WORK_IN_PROGRESS = "WORK_IN_PROGRESS",
  REQUEST_COMPLETED="COMPLETED",
  REQUEST_CANCELLED = "CANCELLED",
  ACTION_ONLY_CHAIN_ASSOCIATION ="ACTION_ONLY_CHAIN_ASSOCIATION",
  APPROVAL_AND_ACTION_CHAIN_ASSOCIATION="APPROVAL_AND_ACTION_CHAIN_ASSOCIATION",
  ACTION_ONLY_USER_ONBOARDING_AND_CHAIN_ASSOCIATION ="ACTION_ONLY_USER_ONBOARDING_AND_CHAIN_ASSOCIATION",
  ACTION_CODE_APPROVAL = "APPROVAL",
  REQUEST_TASK_USER_ONBOARDED ="USER_ONBOARDED",
  REQUEST_TASK_CHAIN_MAPPING = "CHAIN_MAPPING",
  REQUEST_TASK_STORE_MAPPING = "STORE_MAPPING",

  AB_SYSTEM_ADMIN_ID = '3'
  
}

export default Constants;
